import React, { useEffect, useRef, useState } from 'react';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { Box, Typography, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { BackgroundCheck } from './LandsSections/BackgroundCheck';
import { I9Verification } from './LandsSections/I9Verification';
import { StateRequirements } from './LandsSections/StateRequirements';
import { CredentialingReview } from './LandsSections/CredentialingReview';
import { useTranslation } from 'react-i18next';
import { userRoles } from 'oidc/userRoles';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from 'oidc/user.selectors';
import { useFormContext } from 'react-hook-form';
import { placementDetailsAction } from '../../../../../../store/redux-store/placement-details/slice';
import { NursysSection } from './LandsSections/NursysSection';
import { LicenseWrapper } from './LandsSections/LicenseWrapper';
import {
  selectIslandsCancel,
  selectIsLicenseSelect,
  selectIsLicenseSelectRadio,
  selectMiscellaneousPlacementData,
  selectPlacementLandsGtgDetails,
} from '../../../../../../store/redux-store/placement-details/selectors';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { NavigationStatusIcon } from './LandsSections/NavigationStatusIcon/NavigationStatusIcon';
import LandsGtgLastUpdated from './LandsSections/LandsGtgLastUpdated';
import { CredentialsSelection } from 'app/components/Candidate/CandidateProfile/Profile/CandidateDetails.selector';
import { NotRequiredReason } from './LandsSections/NotRequiredReason';
import { Authorized } from 'oidc/userHelper';

const useStyles = makeStyles()({
  root: {
    width: 'calc(100% + 147px)',
    borderBottom: '1px solid #E3DFDF',
  },
  leftGridItem: {
    alignItems: 'center',
    overflow: 'auto',
    height: '700px',
  },
  rightSideMenuItems: {
    marginTop: '6px',
  },
  textColorSelected: {
    textAlign: 'left',
    font: 'normal normal medium 36px / 16px Roboto !important',
    paddingLeft: '20px',
    fontWeight: 500,
    margin: 0,
    color: '#1898D7',
    cursor: 'pointer',
    fontSize: '16px',
  },
  textColorUnselected: {
    textAlign: 'left',
    font: 'normal normal medium 36px / 16px Roboto !important',
    paddingLeft: '20px',
    fontWeight: 500,
    margin: 0,
    cursor: 'pointer',
    fontSize: '16px',
    color: '#333333',
  },
  textColorSelectedSubSection: {
    textAlign: 'left',
    font: 'normal normal medium 14px / 26px Roboto !important',
    fontWeight: 500,
    margin: 0,
    color: '#1898D7',
    cursor: 'pointer',
    fontSize: '14px',
  },
  textColorUnselectedSubSection: {
    textAlign: 'left',
    font: 'normal normal medium 14px / 26px Roboto !important',
    fontWeight: 500,
    margin: 0,
    cursor: 'pointer',
    fontSize: '14px',
    color: '#555555',
  },
  subSectionContainer: {
    marginTop: '5px',
  },
  rightPanel: {
    overflow: 'hidden',
    minHeight: '300px',
    height: '700px',
    paddingTop: '12px !important',
    backgroundColor: '#f5f5f5',
  },
  Titleroot: {
    padding: '0px 5px',
    overflow: 'hidden',
  },
  divider: {
    height: '2px',
    margin: '10px 10px 10px 5px',
    backgroundColor: '#00000014',
  },
  rightSideMainTitle: {
    paddingBottom: '12px',
    paddingLeft: '6px',
    fontWeight: 'bold',
    paddingTop: '5px',
  },
  alignSubSection: {
    // marginLeft: '36px',
    paddingLeft: '3px',
  },
  menuItemContainer: {
    height: '48px',
    paddingLeft: '6px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '8px',
    marginRight: '6px',
  },
  disabledMenu: {
    textAlign: 'left',
    font: 'normal normal medium 14px / 26px Roboto !important',
    fontWeight: 500,
    margin: 0,
    color: '#555555',
    cursor: 'pointer',
    fontSize: '14px',
    '&:hover': {
      cursor: 'default',
    },
  },
  sectionTitle: {
    paddingBottom: '6px',
    paddingTop: '6px',
  },
  subTitleStyle: {
    fontWeight: 'bold',
    marginLeft: '-12px',
  },
});
export const LANDSGTGWrapper = props => {
  const { hasEditPermission } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const LandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const selRequirementId = useSelector(selectIsLicenseSelect);
  const selectCredentials = useSelector(CredentialsSelection);
  const { licensesList } = useSelector(selectMiscellaneousPlacementData);
  const selectlicenseRadio = useSelector(selectIsLicenseSelectRadio);
  const selectIsCancel = useSelector(selectIslandsCancel);
  const [selected, setSelected] = useState<number>(1);
  const gtgRef = useRef<HTMLDivElement | null>(null);
  const bInfoRef = useRef<HTMLDivElement | null>(null);
  const iontRef = useRef<HTMLDivElement | null>(null);
  const sddRef = useRef<HTMLDivElement | null>(null);
  const cddRef = useRef<HTMLDivElement | null>(null);
  const landsRef = useRef<HTMLDivElement | null>(null);
  const licenseRef = useRef<HTMLDivElement | null>(null);
  const nuresyRefy = useRef<HTMLDivElement | null>(null);
  const [supportList, setSupportList] = useState<any[]>([]);
  const [waveandexList, setWaveandexList] = useState<any[]>([]);
  const [initialFormData, setInitialFormData] = React.useState<any>(null);
  const [notRequiredReasonsList, setNotRequiredReasonsList] = React.useState<any[]>([]);
  const [landsNotRequiredReasonsList, setLandsNotRequiredReasonsList] = React.useState<any[]>([]);
  const [isLicenseSelected, setIsLicenseSelected] = useState<any>();
  const [gtgCompletionStatus, setGtgCompletionStatus] = React.useState<{
    backgroundCheck: boolean;
    i9Verification: boolean;
    stateRequirements: boolean;
    finalCredentialingReview: boolean;
  }>({ backgroundCheck: false, i9Verification: false, stateRequirements: false, finalCredentialingReview: false });

  const [landsCompletionStatus, setLandsCompletionStatus] = React.useState<{
    license: boolean;
    nursys: boolean;
  }>({ license: false, nursys: false });
  const [isToggled, setIsToggled] = useState(false);

  const { getValues, setValue } = useFormContext();

  const fetchList = async () => {
    var result = await getSearchFilterOptions('LANDSupportDocList');
    var tempList = result?.map(x => {
      return {
        Id: x.value,
        Description: x.name,
      };
    });
    setSupportList(tempList);
  };

  useEffect(() => {
    if (supportList?.length === 0) {
      fetchList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supportList]);

  useEffect(() => {
    if (waveandexList?.length === 0) {
      fetchWaveandexList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waveandexList]);

  const fetchWaveandexList = async () => {
    var result = await getSearchFilterOptions('LANDCheckStateExcept');
    var tempList = result?.map(x => {
      return {
        Id: x.value,
        Description: x.name,
      };
    });
    setWaveandexList(tempList);
    setValue(
      'piExWave',
      tempList?.find(x => x.Id === LandsGtgDetails?.checkStateExceptId?.toString())?.Description,
      {},
    );
  };

  useEffect(() => {
    if (notRequiredReasonsList?.length === 0) {
      fetchNotRequiredReasonsList();
    }
    if (landsNotRequiredReasonsList?.length === 0) {
      fetchLandsNotRequiredReasonsList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notRequiredReasonsList]);

  const fetchNotRequiredReasonsList = async () => {
    var result = await getSearchFilterOptions('LANDGTGNotRequiredReason');
    var tempList = result?.map(x => {
      return {
        Id: x.value,
        Description: x.name,
      };
    });
    if (tempList) {
      setNotRequiredReasonsList(tempList);
    }
  };

  const fetchLandsNotRequiredReasonsList = async () => {
    var result = await getSearchFilterOptions('LANDNotRequiredReason');
    var tempList = result?.map(x => {
      return {
        Id: x.value,
        Description: x.name,
      };
    });
    if (tempList) {
      setLandsNotRequiredReasonsList(tempList);
    }
  };

  useEffect(() => {
    if (selRequirementId || selectIsCancel) handleFieldChanges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selRequirementId, selectlicenseRadio, selectIsCancel]);

  useEffect(() => {
    let landsStatus = false;
    let gtgStatus = false;
    if (landsCompletionStatus.license == true && landsCompletionStatus.nursys == true) landsStatus = true;
    if (
      gtgCompletionStatus.backgroundCheck == true &&
      gtgCompletionStatus.finalCredentialingReview == true &&
      gtgCompletionStatus.i9Verification == true &&
      gtgCompletionStatus.stateRequirements == true
    )
      gtgStatus = true;
    dispatch(placementDetailsAction.setLandsGtgCompletionStatus({ landsStatus: landsStatus, gtgStatus: gtgStatus }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [landsCompletionStatus, gtgCompletionStatus]);

  useEffect(() => {
    setIsLicenseSelected(licensesList?.find(x => parseInt(x.requirementID) === selRequirementId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selRequirementId]);

  const verifyNursysNotRequired = () => {
    const filterByRequirementIDList: any = licensesList?.filter(
      d => d.licenseNumber === isLicenseSelected?.licenseNumber,
    );
    if (filterByRequirementIDList?.length > 0) {
      return (
        !filterByRequirementIDList[0]?.isClassicLicense &&
        ((filterByRequirementIDList[0]?.requirementTypeID !== 147 &&
          filterByRequirementIDList[0]?.requirementTypeID !== 146) ||
          ((filterByRequirementIDList[0]?.requirementTypeID === 147 ||
            filterByRequirementIDList[0]?.requirementTypeID === 146) &&
            filterByRequirementIDList[0]?.stateID === 23)) &&
        selectlicenseRadio
      );
    }
    return false;
  };

  const completeLandsLicense = data => {
    const filterByRequirementIDList = selectCredentials?.licenses?.filter(d => d.requirementID === selRequirementId);
    return (
      (filterByRequirementIDList[0]?.levelID !== 307 || filterByRequirementIDList[0]?.expirationDate !== null) &&
      data.licenseActive == true &&
      data.licenseMatchAudit == true &&
      data.licenseReviewCleared == true &&
      data.auditScreened == true &&
      data.datesCheckbox1 == true &&
      data.datesCheckbox2 == true &&
      (filterByRequirementIDList[0]?.stateID !== 5 ||
        (filterByRequirementIDList[0]?.stateID == 5 && data.datesCheckbox3 == true)) &&
      (filterByRequirementIDList[0]?.levelID !== 307 ||
        (filterByRequirementIDList[0]?.levelID == 307 && data.datesCheckbox3 == true)) &&
      (filterByRequirementIDList[0]?.levelID !== 307 ||
        (filterByRequirementIDList[0]?.levelID == 307 && data.proofOfResidency == true))
    );
  };

  const completeLandsNursys = data => {
    return (
      (data.pSingleYes == true ||
        (data.pSingleYes == false && data.pSingleReason !== undefined
          ? data.pSingleReason?.length > 0
          : LandsGtgDetails?.statesInNursysReason?.length! > 0)) &&
      (data.pAddressesYes == true ||
        (data.pAddressesYes == false && data.pAddressesReason !== undefined
          ? data.pAddressesReason?.length > 0
          : LandsGtgDetails?.nursysMatchOnFileReason?.length! > 0)) &&
      (data.pMatchesYes == true ||
        (data.pMatchesYes == false && data.pMatchesReason !== undefined
          ? data.pMatchesReason?.length > 0
          : LandsGtgDetails?.nursysLastnameNotMatchesLicenseReason?.length! > 0))
    );
  };

  const completeI9Verification = data => {
    return (
      data.pEVerifyCode !== '' &&
      data.pEVerifyUpload !== null &&
      data.pI9OnFIle == true &&
      data.pFinalAuditCompleted == true &&
      data.pSupportDocOnFile == true &&
      data.pNamesAndNumbersMatch == true &&
      (data.pNotAForeignTraveler == true ||
        ((data.pNotAForeignTraveler == false || data.pNotAForeignTraveler == null) &&
          data.pExceptionFollowUpDate !== null))
    );
  };

  const completeCredentialingReview = data => {
    return (
      (data.pExpYes == false || (data.pExpYes == true && data.pEventsSet == true)) &&
      data.AllVerified == true &&
      (data.pClientYes == true || (data.pClientYes == false && data.pSentToClient !== null))
    );
  };

  useEffect(() => {
    setLandsCompletionStatus({
      license: false,
      nursys: false,
    });
    const initialData = {
      pCrossReferenced: LandsGtgDetails?.crimCheckDate ? true : false,
      pDateOfValidation: LandsGtgDetails?.crimCheckDate,
      pI9OnFIle: LandsGtgDetails?.i9Uploaded,
      pSupportDocOnFile: LandsGtgDetails?.supportDocUploaded,
      pNamesAndNumbersMatch: LandsGtgDetails?.namesNumbersMatchI9,
      pEVerifyCode: LandsGtgDetails?.i9eVerifyCode,
      pEVerifyUpload: LandsGtgDetails?.eVerifyDate,
      pNotAForeignTraveler: LandsGtgDetails?.notForeignTraveler,
      pExceptionFollowUpDate: LandsGtgDetails?.foreignTravelerFUDate,
      pSupportDocList: supportList?.find(x => x.Id === LandsGtgDetails?.supportDocListId?.toString())?.Description,
      pExceptionWaiveEvent: LandsGtgDetails?.missExpEvents,
      pFinalAuditCompleted: LandsGtgDetails?.i9FinalAuditCompleted,
      pReason: LandsGtgDetails?.checkStateReason,
      pNotRequiredReasonId: LandsGtgDetails?.notRequiredReasonId || null,
      pNotRequiredReason: LandsGtgDetails?.notRequiredReason || null,
      piExWave: waveandexList?.find(x => x.Id === LandsGtgDetails?.checkStateExceptId?.toString())?.Description,
      pYes: LandsGtgDetails?.checkState ? LandsGtgDetails?.checkState : false,
      pExpYes: LandsGtgDetails?.noExpAssign ? LandsGtgDetails?.noExpAssign : false,
      pEventsSet: LandsGtgDetails?.missExpEvents,
      AllVerified: LandsGtgDetails?.allCertificationsVerified,
      pClientYes: LandsGtgDetails?.packetNotRequired ? LandsGtgDetails?.packetNotRequired : false,
      pSentToClient: LandsGtgDetails?.packetSentDate,
      licenseActive: LandsGtgDetails?.licenseActive,
      licenseReviewCleared: LandsGtgDetails?.licenseReviewTeamClearedHits,
      licenseMatchAudit: LandsGtgDetails?.hitsOnLicenseMatchAudit,
      auditScreened: LandsGtgDetails?.auditScreenedWithClient,
      datesCheckbox1: LandsGtgDetails?.licenseIssuedAfterGraduation,
      datesCheckbox2: LandsGtgDetails?.checkedDob,
      datesCheckbox3: LandsGtgDetails?.confirmCaLicense,
      reason: LandsGtgDetails?.confirmCaLicenseReason,
      proofOfResidency: LandsGtgDetails?.isProofOfResidencyOnFileForCompact,
      pSingleYes: (!LandsGtgDetails?.isAlliedClinician && LandsGtgDetails?.statesInNursys) || false,
      pSingleNo: LandsGtgDetails?.statesInNursys || false,
      pAddressesYes: (!LandsGtgDetails?.isAlliedClinician && LandsGtgDetails?.nursysMatchOnFile) || false,
      pAddressesNo: LandsGtgDetails?.nursysMatchOnFile || false,
      pMatchesYes: (!LandsGtgDetails?.isAlliedClinician && LandsGtgDetails?.nursysLastnameMatchesLicense) || false,
      pMatchesNo: LandsGtgDetails?.nursysLastnameMatchesLicense || false,
      pSingleReason: LandsGtgDetails?.statesInNursysReason || '',
      pAddressesReason: LandsGtgDetails?.nursysMatchOnFileReason || '',
      pMatchesReason: LandsGtgDetails?.nursysLastnameNotMatchesLicenseReason || '',
    };
    setInitialFormData(initialData);
    setGtgCompletionStatus({
      backgroundCheck: initialData.pCrossReferenced == true && initialData.pDateOfValidation !== null,
      i9Verification: completeI9Verification(initialData),
      stateRequirements:
        initialData.pYes == true ||
        (initialData.pYes == false && initialData.pReason !== '' && initialData.pReason !== null),
      finalCredentialingReview: completeCredentialingReview(initialData),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFieldChanges = () => {
    const editedData = {
      pCrossReferenced: getValues('pCrossReferenced'),
      pDateOfValidation: getValues('pDateOfValidation'),
      pI9OnFIle: getValues('pI9OnFIle'),
      pFinalAuditCompleted: getValues('pFinalAuditCompleted'),
      pSupportDocOnFile: getValues('pSupportDocOnFile'),
      pNamesAndNumbersMatch: getValues('pNamesAndNumbersMatch'),
      pEVerifyCode: getValues('pEVerifyCode'),
      pEVerifyUpload: getValues('pEVerifyUpload'),
      pNotAForeignTraveler: getValues('pNotAForeignTraveler'),
      pExceptionFollowUpDate: getValues('pExceptionFollowUpDate'),
      pSupportDocList: getValues('pSupportDocList'),
      pExceptionWaiveEvent: getValues('pExceptionWaiveEvent'),
      pReason: getValues('pReason'),
      pNotRequiredReasonId: getValues('pNotRequiredReasonId'),
      pNotRequiredReason: getValues('pNotRequiredReason'),
      piExWave: getValues('piExWave'),
      pYes: getValues('pYes') !== null ? getValues('pYes') : false,
      pExpYes: getValues('pExpYes'),
      pEventsSet: getValues('pEventsSet'),
      AllVerified: getValues('pAllVerified'),
      pClientYes: getValues('pClientYes'),
      pSentToClient: getValues('pSentToClient'),
      licenseActive: getValues('licenseActive'),
      licenseReviewCleared: getValues('licenseReviewCleared'),
      licenseMatchAudit: getValues('licenseMatchAudit'),
      auditScreened: getValues('auditScreened'),
      datesCheckbox1: getValues('datesCheckbox1'),
      datesCheckbox2: getValues('datesCheckbox2'),
      datesCheckbox3: getValues('datesCheckbox3'),
      reason: getValues('reason'),
      proofOfResidency: getValues('proofOfResidency'),
      pSingleYes: getValues('pSingleYes') !== undefined ? getValues('pSingleYes') : initialFormData?.pSingleYes,
      pSingleNo: getValues('pSingleNo') !== undefined ? getValues('pSingleNo') : initialFormData?.pSingleNo,
      pAddressesYes:
        getValues('pAddressesYes') !== undefined ? getValues('pAddressesYes') : initialFormData?.pAddressesYes,
      pAddressesNo: getValues('pAddressesNo') !== undefined ? getValues('pAddressesNo') : initialFormData?.pAddressesNo,
      pMatchesYes: getValues('pMatchesYes') !== undefined ? getValues('pMatchesYes') : initialFormData?.pMatchesYes,
      pMatchesNo: getValues('pMatchesNo') !== undefined ? getValues('pMatchesNo') : initialFormData?.pMatchesNo,
      pSingleReason: getValues('pSingleReason'),
      pAddressesReason: getValues('pAddressesReason'),
      pMatchesReason: getValues('pMatchesReason'),
    };
    setLandsCompletionStatus({
      license: completeLandsLicense(editedData) && (selectlicenseRadio || false),
      nursys: completeLandsNursys(editedData) && (selectlicenseRadio || false),
    });
    setGtgCompletionStatus({
      backgroundCheck: editedData.pCrossReferenced == true && editedData.pDateOfValidation !== null,
      i9Verification: completeI9Verification(editedData),
      stateRequirements: editedData.pYes == true || (editedData.pYes == false && editedData.pReason !== ''),
      finalCredentialingReview: completeCredentialingReview(editedData),
    });
  };

  const menuNames = {
    license: t('placement.profile.tabs.LANDS/GTGTab.rightSideMenu.License'),
    nursys: t('placement.profile.tabs.LANDS/GTGTab.rightSideMenu.Nursys'),
    criminalBackgroundCheck: t('placement.profile.tabs.LANDS/GTGTab.rightSideMenu.criminalBackgroundCheck'),
    i9Verification: t('placement.profile.tabs.LANDS/GTGTab.rightSideMenu.i9Verification'),
    stateRequirements: t('placement.profile.tabs.LANDS/GTGTab.rightSideMenu.stateRequirements'),
    finalCredentialingReview: t('placement.profile.tabs.LANDS/GTGTab.rightSideMenu.finalCredentialingReview'),
  };
  const handleClick = index => {
    setSelected(index);
    switch (index) {
      case 0:
        landsRef?.current?.scrollIntoView({
          behavior: 'smooth',
        });
        break;
      case 1:
        licenseRef?.current?.scrollIntoView({
          behavior: 'smooth',
        });
        break;
      case 2:
        nuresyRefy?.current?.scrollIntoView({
          behavior: 'smooth',
        });
        break;
      case 3:
        gtgRef?.current?.scrollIntoView({
          behavior: 'smooth',
        });
        break;
      case 4:
        bInfoRef?.current?.scrollIntoView({
          behavior: 'smooth',
        });
        break;
      case 5:
        iontRef?.current?.scrollIntoView({
          behavior: 'smooth',
        });
        break;
      case 6:
        sddRef?.current?.scrollIntoView({
          behavior: 'smooth',
        });
        break;
      case 7:
        cddRef?.current?.scrollIntoView({
          behavior: 'smooth',
        });
        break;
    }
  };
  const handleToggle = e => {
    setIsToggled(e);
  };
  useEffect(() => {
    setIsToggled(LandsGtgDetails?.notRequired || false);
  }, [LandsGtgDetails]);
  const renderMenu = (isComplete, isNotRequired, menuName, currentItem, selectedItem) => {
    return (
      <>
        <LayoutGrid container direction="row" className={classes.alignSubSection}>
          {renderStatusIcon(isComplete, isNotRequired)}
          <LayoutGridItem item style={{ padding: '10px 0px' }}>
            <Typography
              className={
                isNotRequired //not required flag here
                  ? `${classes.disabledMenu}`
                  : selectedItem === currentItem
                  ? `${classes.textColorSelectedSubSection} ${classes.subSectionContainer}`
                  : `${classes.textColorUnselectedSubSection} ${classes.subSectionContainer}`
              }
              variant="subtitle1"
              gutterBottom
              component="div"
            >
              {menuName}
            </Typography>
          </LayoutGridItem>
        </LayoutGrid>
      </>
    );
  };
  const renderStatusIcon = (isCompleted, isNotRequired) => {
    return (
      <LayoutGridItem className={classes.iconContainer}>
        <NavigationStatusIcon isComplete={isCompleted} isNotRequired={isNotRequired} />
      </LayoutGridItem>
    );
  };
  return (
    <LayoutGrid classes={{ root: classes.root }}>
      <LayoutGridItem item xs={12} md={8} className={classes.leftGridItem}>
        <LayoutGrid container direction="column" data-testid="container" className={classes.Titleroot}>
          <LayoutGridItem>
            <div>
              <LandsGtgLastUpdated />
            </div>
          </LayoutGridItem>
          <LayoutGridItem item>
            <div ref={licenseRef}>
              <LicenseWrapper
                handleFieldChanges={handleFieldChanges}
                notRequiredReasonsList={landsNotRequiredReasonsList}
                handleToggle={handleToggle}
              />
            </div>
          </LayoutGridItem>
          {!isToggled && (
            <LayoutGridItem item>
              <div ref={nuresyRefy}>
                <NursysSection handleFieldChanges={handleFieldChanges} />
              </div>
            </LayoutGridItem>
          )}
          <Divider variant="middle" className={classes.divider} />
          {LandsGtgDetails?.gtgNotRequired ? (
            <>
              <LayoutGridItem item className={classes.sectionTitle}>
                <div ref={gtgRef} style={{ paddingLeft: '20px' }}>
                  <Typography variant="subtitle1" component="div" className={classes.subTitleStyle}>
                    {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.GoodToGoTitle')}
                  </Typography>
                </div>
              </LayoutGridItem>
              <NotRequiredReason
                hasEditPermission={Authorized(
                  [userRoles.credentialing_Leadership, userRoles.credentialing_TeamMember],
                  user.userInfo,
                )}
                notRequiredReasonsList={notRequiredReasonsList}
                handleFieldChanges={handleFieldChanges}
              />
            </>
          ) : (
            <>
              <LayoutGridItem item>
                <div ref={gtgRef}>
                  <Typography className={classes.rightSideMainTitle}>
                    {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.goodToGoVarificationRequired')}
                  </Typography>
                </div>
              </LayoutGridItem>
              <Divider variant="middle" className={classes.divider} />
              <LayoutGridItem item>
                <div ref={bInfoRef}>
                  <BackgroundCheck hasEditPermission={hasEditPermission} handleFieldChanges={handleFieldChanges} />
                </div>
              </LayoutGridItem>
              <LayoutGridItem item>
                <div ref={iontRef}>
                  <I9Verification
                    hasEditPermission={hasEditPermission}
                    supportList={props.supportList}
                    handleFieldChanges={handleFieldChanges}
                  />
                </div>
              </LayoutGridItem>
              <LayoutGridItem item>
                <div ref={sddRef}>
                  <StateRequirements
                    hasEditPermission={hasEditPermission}
                    waveandexList={props.waveandexList}
                    handleFieldChanges={handleFieldChanges}
                  />
                </div>
              </LayoutGridItem>
              <LayoutGridItem item>
                <div ref={cddRef}>
                  <CredentialingReview hasEditPermission={hasEditPermission} handleFieldChanges={handleFieldChanges} />
                </div>
              </LayoutGridItem>
            </>
          )}
        </LayoutGrid>
      </LayoutGridItem>
      <LayoutGridItem xs={3} classes={{ root: classes.rightPanel }}>
        <Box className={classes.rightSideMenuItems}>
          <LayoutGridItem item xs={12} onClick={() => handleClick(0)} className={classes.menuItemContainer}>
            <LayoutGrid container direction="row">
              <LayoutGridItem item style={{ padding: '12px 0px' }}>
                <Typography
                  className={[1, 2].indexOf(selected) > -1 ? classes.textColorSelected : classes.textColorUnselected}
                  variant="subtitle1"
                  gutterBottom
                  component="div"
                >
                  {t('placement.profile.tabs.LANDS/GTGTab.rightSideMenu.LANDS')}
                </Typography>
              </LayoutGridItem>
            </LayoutGrid>
          </LayoutGridItem>
          <LayoutGridItem item xs={12} onClick={() => handleClick(1)} className={classes.menuItemContainer}>
            {renderMenu(landsCompletionStatus.license, isToggled, menuNames.license, 1, selected)}
          </LayoutGridItem>
          <LayoutGridItem item xs={12} onClick={() => handleClick(2)} className={classes.menuItemContainer}>
            {renderMenu(
              landsCompletionStatus.nursys,
              isToggled ||
                (LandsGtgDetails?.licenseNumber === isLicenseSelected?.licenseNumber &&
                  LandsGtgDetails?.isAlliedClinician) ||
                verifyNursysNotRequired(),
              menuNames.nursys,
              2,
              selected,
            )}
          </LayoutGridItem>
          <LayoutGridItem item xs={12} onClick={() => handleClick(3)} className={classes.menuItemContainer}>
            <LayoutGrid container direction="row">
              <LayoutGridItem item style={{ padding: '12px 0px' }}>
                <Typography
                  className={
                    [4, 5, 6, 7].indexOf(selected) > -1 ? classes.textColorSelected : classes.textColorUnselected
                  }
                  variant="subtitle1"
                  gutterBottom
                  component="div"
                >
                  {t('placement.profile.tabs.LANDS/GTGTab.rightSideMenu.goodToGo')}
                </Typography>
              </LayoutGridItem>
            </LayoutGrid>
          </LayoutGridItem>
          <LayoutGridItem item xs={12} onClick={() => handleClick(4)} className={classes.menuItemContainer}>
            {renderMenu(
              gtgCompletionStatus.backgroundCheck,
              LandsGtgDetails?.gtgNotRequired,
              menuNames.criminalBackgroundCheck,
              4,
              selected,
            )}
          </LayoutGridItem>
          <LayoutGridItem item xs={12} onClick={() => handleClick(5)} className={classes.menuItemContainer}>
            {renderMenu(
              gtgCompletionStatus.i9Verification,
              LandsGtgDetails?.gtgNotRequired,
              menuNames.i9Verification,
              5,
              selected,
            )}
          </LayoutGridItem>
          <LayoutGridItem item xs={12} onClick={() => handleClick(6)} className={classes.menuItemContainer}>
            {renderMenu(
              gtgCompletionStatus.stateRequirements,
              LandsGtgDetails?.gtgNotRequired,
              menuNames.stateRequirements,
              6,
              selected,
            )}
          </LayoutGridItem>
          <LayoutGridItem item xs={12} onClick={() => handleClick(7)} className={classes.menuItemContainer}>
            {renderMenu(
              gtgCompletionStatus.finalCredentialingReview,
              LandsGtgDetails?.gtgNotRequired,
              menuNames.finalCredentialingReview,
              7,
              selected,
            )}
          </LayoutGridItem>
        </Box>
      </LayoutGridItem>
    </LayoutGrid>
  );
};
